import { Children } from 'react';
import styled, { css } from 'styled-components';

import { media } from '@/themes';
import Card from '@/components/card';

const MenuContainer = styled(Card)``;

const Container = styled.div`
  display: inline-block;
  position: relative;

  ${media.sm`
    display: block;
  `};

  ${MenuContainer} {
    left: 50%;
    min-width: 15em;
    opacity: 0;
    position: absolute;
    padding: .5em 0;
    pointer-events: none;
    top: 100%;
    transform: translate(-50%, 1em);
    transition-duration: 250ms;
    transition-property: opacity, transform;
    will-change: opacity, transform;

    ${media.sm`
      box-shadow: none;
      opacity: 1;
      position: static;
      pointer-events: unset;
      transform: none;
      transition: none;
    `};
  }

  &:hover ${MenuContainer}, &:active ${MenuContainer} {
    opacity: 1;
    pointer-events: unset;
    transform: translate(-50%, 0);

    ${media.sm`
      transform: none;
    `};
  }
`;

const Title = styled.span`
  cursor: default;
  color: ${props => props.theme.colors.typography.subtle};
  display: inline-block;
  padding: .5em 1em;

  ${media.sm`
    display: block;
    font-size: .8em;
    padding: 1em 1.5em .5em;
  `};
`;

const Item = styled.div`
  cursor: pointer;

  &:hover {
    background: ${props => props.theme.colors.background.primary};
  }
`;

const Menu = ({ children, title }) => {
  return (
    <Container>
      <Title>{title}</Title>
      <MenuContainer>
        {Children.map(children, (child, index) => (
          <Item key={index}>
            {child}
          </Item>
        ))}
      </MenuContainer>
    </Container>
  );
};

export default Menu;
